import Box from '@mui/material/Box';
import { useTheme, type ThemeNames } from '../../../../../theme';
import { BodyS } from '../../../../../typography';

import type { JSX } from 'react';

export type DropdownCellTitleProps = {
  title: string;
  themeName?: ThemeNames;
};

export const DropdownCellTitle = ({
  title,
  themeName,
}: DropdownCellTitleProps): JSX.Element => {
  const theme = useTheme(themeName);

  return (
    <Box
      sx={{
        display: 'flex',
        maxWidth: '100%',
        alignItems: 'center',
        justifyContent: 'flex-start',
        height: 40,
        padding: theme.spacing(2, 3),
      }}
    >
      <BodyS fontWeight='medium' color={theme.text.generic.secondary}>
        {title}
      </BodyS>
    </Box>
  );
};
